module.exports = __webpack_public_path__ + "assets/img/belenkov.a66b1b54.webp";